module.exports = __webpack_public_path__ + "static/media/maragogi-al.d5e365d4.jpg";